import { useState } from 'react';

export function useAlertModalStatus(initialAlertModalStatus) {
  const [alertModalStatus, setAlertModalStatus] = useState({
    isOpen: initialAlertModalStatus,
    title: '',
    descr: {
      content: '',
      values: null,
    },
  });

  function handleChange({ event, isOpen, title, descr }) {
    if (event) event.stopPropagation();
    setAlertModalStatus({
      ...alertModalStatus,
      isOpen,
      title: title ?? alertModalStatus.title,
      descr: descr ?? alertModalStatus.descr,
    });
  }

  return {
    ...alertModalStatus,
    onChangeStatus: handleChange,
  };
}
